import { render, staticRenderFns } from "./PlanejamentoContratoListDados.vue?vue&type=template&id=8506d4c2"
import script from "./PlanejamentoContratoListDados.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoListDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports